import { ModelBody, ModelHeader, ModelTitle } from '../style';
import { ModelBtn } from 'styles';
import { useDispatch, useSelector } from 'react-redux';
import { useRef, useState } from 'react';
import { updateExistingPayments } from 'redux/payment';
import { ButtonLoader } from 'components/Loader';
import { closeModel } from 'redux/model';
import { showSnackbar } from 'redux/snackbar';
import { usePaymentActionMutation } from 'redux/rtkQuery/paymentApiSlice';
import { COUNTRY, PAYFLOW_PRO, PAYMENT_ACTION, SEVERITY } from 'utils/constants/variable';
import CBCardComponent from '../../PaymentGateways/ExternalCard';

const EditPayment = () => {
  const { users } = useSelector((state) => state.portal);
  const { loggedInUserId } = useSelector((state) => state.auth);
  const { data } = useSelector((state) => state.model);
  const { existingPayments } = useSelector((state) => state.payment);
  const [paymentAction] = usePaymentActionMutation();

  const { paymentSourceId, memberNumber } = data;
  const selectedPayment = existingPayments.find((p) => p.id === paymentSourceId);
  const [isProcessing, setIsProcessing] = useState(false);

  const dispatch = useDispatch();
  const childRef = useRef();

  const handleClose = () => dispatch(closeModel());

  const handleSubmit = async (ev) => {
    ev.preventDefault();

    const { firstName, lastName, addressDetails } = users.find(
      (user) => user.memberNumber === loggedInUserId
    );

    const additionalData = {
      firstName: firstName,
      lastName: lastName,
      addressLine1: addressDetails.addressLine1,
      addressLine2: addressDetails.addressLine2,
      city: addressDetails.suburb,
      state: addressDetails.state,
      countryCode: COUNTRY.AUSTRALIA,
      zip: addressDetails.postcode
    };

    setIsProcessing(true);
    await childRef.current
      .tokenize(additionalData)
      .then((resp) => {
        const payload = {
          memberNumber,
          action: PAYMENT_ACTION.UPDATE,
          paymentDetails: {
            id: paymentSourceId,
            token: resp.token,
            paymentMethod: PAYFLOW_PRO
          }
        };
        paymentAction(payload)
          .unwrap()
          .then((response) => {
            dispatch(updateExistingPayments(response));
            handleClose();
          })
          .catch((err) => {
            console.log(err);
            dispatch(showSnackbar({ severity: 'error', message: err?.data?.message }));
          })
          .finally(() => {
            setIsProcessing(false);
          });
      })
      .catch((err) => {
        console.log(err);
        setIsProcessing(false);
        dispatch(
          showSnackbar({ severity: SEVERITY.WARNING, message: 'Please enter a valid card details' })
        );
      });
  };

  return (
    <>
      <ModelHeader closeButton>
        <ModelTitle>Edit Payment details</ModelTitle>
      </ModelHeader>
      <ModelBody>
        <CBCardComponent ref={childRef} card={selectedPayment.source} />

        <div className="text-center mb-2">
          <ModelBtn
            className={isProcessing ? 'disable-btn' : 'active-btn'}
            isProcessing={isProcessing}
            disabled={isProcessing}
            onClick={handleSubmit}>
            {isProcessing ? <ButtonLoader /> : 'Save'}
          </ModelBtn>
        </div>
      </ModelBody>
    </>
  );
};

export default EditPayment;
